// The web's mirror of domain.Change. See pricing.ts for why these exist twice.

export type PaymentMethod = 'cash' | 'card';

export interface ChangeResult {
	/** What the cashier hands back. Zero for a card, and zero when short. */
	changeMinor: number;
	/** False only when cash was offered and it does not cover the bill. */
	ok: boolean;
}

/**
 * What the cashier hands back, and whether the tender covers the bill.
 *
 * The payment panel calls this on every keypad tap, so the change under the
 * keypad is the same number the server will store. Card is not a special case
 * with its own arithmetic: it reports zero change and always covers, which is
 * how the stored row is shaped too.
 *
 * The panel uses `ok` to enable Confirm. It is not a substitute for the
 * server's check -- a client that decided its own tender was enough could
 * decide a short one was.
 */
export function change(
	method: PaymentMethod,
	totalMinor: number,
	tenderedMinor: number,
): ChangeResult {
	if (method === 'card') return { changeMinor: 0, ok: true };
	if (tenderedMinor < totalMinor) return { changeMinor: 0, ok: false };
	return { changeMinor: tenderedMinor - totalMinor, ok: true };
}
